module.exports = __webpack_public_path__ + "img/file-06.3525852d.svg";